(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/views/odds-slider/matchen-odds-empty.js') >= 0) return;  svs.modules.push('/modules/matchen/views/odds-slider/matchen-odds-empty.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.matchen=_svs.matchen||{};
_svs.matchen.templates=_svs.matchen.templates||{};
svs.matchen.templates.matchen_odds_empty = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "      Din kupong får innehålla max 10 000 rader.\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"exceedsPrintableRowsLimit") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":8,"column":4}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    return "      Mina odds kan inte visa fler än 100 rader.\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "      För att se aktuella odds måste du kryssa i minst ett hemma- och ett bortaresultat i varje match.\n    ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p class=\"padding-top-1\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"exceedsMaxRows") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":8,"column":11}}})) != null ? stack1 : "")
    + "</p>";
},"useData":true});
Handlebars.partials['svs-matchen-matchen_odds_empty'] = svs.matchen.templates.matchen_odds_empty;
})(svs, Handlebars);


 })(window);